import React from 'react';
import classNames from 'classnames';

import css from './ListingBadge.module.css';

/**
 * One badge pill.
 *
 * Takes a resolved label rather than a translation key: cards show the badge
 * category ("Ausgezeichnet") while the listing page names the specific award,
 * so the surface decides and this component stays dumb.
 *
 * @component
 * @param {Object} props
 * @param {string?} props.className add style rules in addition to css.root
 * @param {string?} props.rootClassName overwrite this component's own css.root
 * @param {string} props.label text shown in the pill
 * @returns {JSX.Element|null} the pill, or null when there is no label
 */
const ListingBadge = props => {
  const { className, rootClassName, label } = props;

  if (!label) {
    return null;
  }

  return <span className={classNames(rootClassName || css.root, className)}>{label}</span>;
};

export default ListingBadge;
